const SITE_NAME = "Hordaland Kunstsenter";

export const SEO = {
  home: {
    title: SITE_NAME,
    description:
      "Hordaland Kunstsenter er et kunstsenter i Bergen som fremmer samtidskunst gjennom utstillinger, program og residenser.",
    keywords: "kunst, samtidskunst, Bergen, kunstsenter, utstilling",
  },
  program: {
    title: `Program | ${SITE_NAME}`,
    description: "Utstillinger og program ved Hordaland Kunstsenter.",
    keywords: "program, utstilling, kunst, Bergen",
  },
  possibilities: {
    title: `Muligheter | ${SITE_NAME}`,
    description:
      "Ledige stillinger, stipend og muligheter ved Hordaland Kunstsenter.",
    keywords: "muligheter, stipend, utlysning, kunstner",
  },
  triangle: {
    title: `Triangle | ${SITE_NAME}`,
    description:
      "Triangle Network residency og prosjekter ved Hordaland Kunstsenter.",
    keywords: "triangle, residency, artist, internasjonalt",
  },
  artAndPublic: {
    title: `Kunst og offentlighet | ${SITE_NAME}`,
    description: "Kunst og offentlighet – prosjekter og program.",
    keywords: "kunst, offentlighet, prosjekt",
  },
  artistInResidency: {
    title: `Artist in Residency | ${SITE_NAME}`,
    description:
      "Kunstnerresidenser og artistprogrammet ved Hordaland Kunstsenter.",
    keywords: "artist in residency, residens, kunstner",
  },
  about: {
    title: `Om / Kontakt | ${SITE_NAME}`,
    description: "Om Hordaland Kunstsenter – ansatte, styre og kontaktinfo.",
    keywords: "om, kontakt, ansatte, styre",
  },
  bookstore: {
    title: `Bokhandel + Kafé | ${SITE_NAME}`,
    description: "Bokhandel og kafé ved Hordaland Kunstsenter.",
    keywords: "bokhandel, kafé, tidsskrift, bøker",
  },
  aboutHks: {
    title: `Om HKS | ${SITE_NAME}`,
    description: "Historikk og bakgrunn om Hordaland Kunstsenter.",
    keywords: "om HKS, historikk, bakgrunn",
  },
  search: {
    title: `Søk | ${SITE_NAME}`,
    description: "Søk i Hordaland Kunstsenters innhold.",
    keywords: "søk, search",
  },
};

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://kunstsenter.no";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;
